export default __webpack_public_path__ + "34933c2884c0ef9d66af4277bae89d1e.svg";